const dateToString = (date) => {
  if (date) {
    const [datePart, timePart] = date.split('T')
    const [year, month, day] = datePart.split('-')
    const time = timePart ? timePart.substring(0, 5) : ''

    const mom = {}
    mom.day = `${day}/${month}/${year}`
    mom.time = time
    mom.full = `${mom.day} ${time}`.trim()
    mom.dayMin = `${day}/${month}`
    mom.withYear = `${day}/${month}/${year}`
    mom.withYearMinimal = `${day}/${month}/${year.substring(2, 4)}`

    return mom
  }
  return {}
}

const getAge = (dateString) => {
  const today = new Date()
  const birthDate = new Date(dateString)
  const age = today.getFullYear() - birthDate.getFullYear()
  return age
}

const getLicenseAge = (dateString, licenseYear) => {
  const birthDate = new Date(dateString)
  return licenseYear - birthDate.getFullYear()
}

const datesAreOnSameDay = (first, second) =>
  first.getFullYear() === second.getFullYear() &&
  first.getMonth() === second.getMonth() &&
  first.getDate() === second.getDate()

const getNextDayOfWeek = (fromDate, dayOfWeek) => {
  const date = new Date(fromDate.getTime())
  date.setDate(date.getDate() + ((dayOfWeek + 7 - date.getDay()) % 7))
  return date
}

const isWeekend = () => {
  const forceWeekend = process.env.FORCE_WEEKEND_MODE === 'true'
  if (forceWeekend) return true

  const day = new Date().getDay()
  return day === 0 || day === 6
}

const isSameDay = (date1, date2) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  )
}

const isToday = (dateString) => {
  if (!dateString) return false

  const matchDate = new Date(dateString)
  const today = new Date()

  const matchDateSpain = new Date(
    matchDate.toLocaleString('en-US', { timeZone: 'Europe/Madrid' })
  )
  const todaySpain = new Date(
    today.toLocaleString('en-US', { timeZone: 'Europe/Madrid' })
  )

  return isSameDay(matchDateSpain, todaySpain)
}

const getSpanishTimezoneLabel = () => {
  return new Date()
    .toLocaleTimeString('es-ES', {
      timeZone: 'Europe/Madrid',
      timeZoneName: 'short'
    })
    .includes('CEST')
    ? 'CEST'
    : 'CET'
}

const isDeviceTimezoneSpanish = ({ minimal = false } = {}) => {
  const deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const spanishTimezones = ['Europe/Madrid']
  const label = getSpanishTimezoneLabel()
  return !spanishTimezones.includes(deviceTimezone)
    ? minimal
      ? ` (${label})`
      : ` (Hora espanyola - ${label})`
    : ''
}

export {
  dateToString,
  getAge,
  getLicenseAge,
  datesAreOnSameDay,
  getNextDayOfWeek,
  isWeekend,
  isToday,
  isDeviceTimezoneSpanish
}
